import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";
import moment from "moment";
import { useGetDesignEngCriticalDrawingListByDaysQuery, useGetDesignEngKpiDrillDownQuery, useGetDesignEngKpiAgeingDrillDownQuery, useGetDesignEngIEStatusKpiDrillDownQuery } from "store/slices/apis/designEngineeringDashboardSlice";

const EngListPopup = (props) => {
    const { header, open, handleClose, data, label } = props;
    console.log("engData", data)
    const { projectId } = useParams();

    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    const queryParams = {
        ...data,
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize
    };

    const drilDownParams = {
        ...data,
        ProjectId: projectId,
        PageNumber: pageNumber,
        PageSize: pageSize
    }



    const {
        data: upcomingCriticalData,
        isLoading: criticalLoading,
        isFetching: criticalFetching
    } = useGetDesignEngCriticalDrawingListByDaysQuery(queryParams, {
        skip: label !== "ucd"
    });

    const {
        data: engineeringList,
        isLoading,
        isFetching
    } = useGetDesignEngKpiDrillDownQuery(drilDownParams, {
        skip: label !== "kpi"
    });

    const {
        data: ieStatusengineeringList,
        isLoading: ieStatusLoading,
        isFetching: ieStatusFetching
    } = useGetDesignEngIEStatusKpiDrillDownQuery(drilDownParams, {
        skip: label !== "IEStatuskpi"
    });

    const {
        data: ageingList,
        isLoading: loading,
        isFetching: fetching
    } = useGetDesignEngKpiAgeingDrillDownQuery(drilDownParams, {
        skip: label !== "ageing"
    });

    const tableData = engineeringList?.data ?? [];
    const ieStatustableData = ieStatusengineeringList?.data ?? [];
    const criticalData = upcomingCriticalData?.data ?? [];
    const criticalDataRecords = upcomingCriticalData?.totalRecords ?? 0;
    const totalRecords = engineeringList?.totalRecords ?? 0;
    const ieStatustotalRecords = ieStatusengineeringList?.totalRecords ?? 0;

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
    };

    const getData = (val) => {
        switch (val) {
            case "kpi":
                return tableData;
            case "IEStatuskpi":
                return ieStatustableData;
            case "ucd":
                return criticalData;
            default:
                return [];
        }
    }

    const getTotalRecords = (val) => {
        switch (val) {
            case "kpi":
                return totalRecords;
            case "IEStatuskpi":
                return ieStatustotalRecords;
            case "ucd":
                return criticalDataRecords
            default:
                return 0;
        }
    }

    const columns = [
        {
            name: "ID",
            field: "customId",
            width: "70px",
            sticky: true,
        },
        {
            name: "Asset",
            field: "projectCode",
            width: "200px",
            sticky: true,
        },
        {
            name: "Document Type",
            field: "designType"
        },
        {
            name: "Discipline",
            field: "discipline",
        },
        {
            name: "Consultant",
            field: "consultant",
        },
        {
            name: "Drawing Title",
            field: "title",
            width: "140px",
        },
        {
            name: "Drawing Number",
            field: "drgNo",
        },
        {
            name: "Latest Revision Date",
            field: "lastSubmissionDate",
            renderer: (row) => (
                row?.lastSubmissionDate ? moment(row.lastSubmissionDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Latest Revision No",
            field: "lastRevisionNo",
        },
        {
            name: "GFC Approval Status",
            field: "gfcApprovalStatus",
            renderer: (row) => (
                <StatusBadge status={row.gfcApprovalStatus} />
            )
        },
        {
            name: "GFC Approval Date",
            field: "gfcApprovalDate",
            renderer: (row) => (
                row?.gfcApprovalDate ? moment(row.gfcApprovalDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Status",
            field: "status",
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Target Date",
            field: "targetDate",
            renderer: (row) => (
                row?.targetDate ? moment(row.targetDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "IE Approval Date",
            field: "ieApprovalDate",
            renderer: (row) => (
                row?.ieApprovalDate ? moment(row.ieApprovalDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "IE Approval Status",
            field: "ieApprovalStatus",
            renderer: (row) => (
                <StatusBadge status={row.ieApprovalStatus} />
            )
        },
    ];

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={columns}
                            data={getData(label)}
                            createSortHandler={handleRequestSort}
                            isLoading={isLoading || isFetching}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={getTotalRecords(label)}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EngListPopup;
